const $$splitComponentImporter = () => import('/Users/Javvad_1/Desktop/Petso_Dev/monorepo/petso-pro/src/routes/dashboard/member.$memberId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { User, XCircle } from 'lucide-react';
export const Route = createFileRoute('/dashboard/member/$memberId')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface MemberProfile {
  id: string;
  businessId: string;
  userClerkId: string | null;
  roleId: string;
  roleName: string;
  roleType: string;
  status: string;
  inviteEmail: string;
  displayName: string | null;
  title: string | null;
  phone: string | null;
  specializations: string[] | null;
  joinedAt: string | null;
  createdAt: string;
}
interface MemberStats {
  totalAssigned: number;
  totalCompleted: number;
  totalInProgress: number;
  totalCancelled: number;
  completionRate: number;
}
interface RecentBooking {
  id: string;
  petName: string;
  ownerName: string;
  serviceName: string | null;
  serviceType: string | null;
  scheduledDate: string;
  scheduledTime: string;
  status: string;
  priority: string;
  completedAt: string | null;
}
interface AuditEntry {
  id: string;
  action: string;
  entityType: string;
  entityId: string | null;
  details: Record<string, unknown> | null;
  createdAt: string;
}

// ─── Stat Card Component ────────────────────────────────────────────────────